import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Container,
  Row,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import {
  formatDateStringToKorea,
} from "helpers/format";
import { Collapse } from "antd";
import { IWorkHistory } from "api/types/_user";

registerLocale("en", en);
registerLocale("ko", ko);

const WorkHistoryTab = ({data} : any) => {
  const { t, i18n } = useTranslation();
 
  const [dataFormat, setDataFormat] = useState<IWorkHistory[]>([]);

  useEffect(() => {
    if(data?.work_experiences?.length > 0) {
      const workHistories = data?.work_experiences?.map((item: IWorkHistory) => {
        const startDate = formatDateStringToKorea(item?.start_date || "", "YYYY-MM-DD") || '';
        const endDate = formatDateStringToKorea(item?.end_date || "", "YYYY-MM-DD") || '';
        return {
          title: `${item?.title} | ${item?.position} | ${startDate} ~ ${endDate}`,
          details: [
            { label: "Title of the Work", value: item?.title },
            { label: "Role", value: item?.position },
            { label: "Venue", value: item?.organization },
            { label: "Start Date", value: startDate },
            { label: "End Date", value: endDate },
            { label: "Description", value: item?.description },
          ]
        };
      })
      setDataFormat(workHistories)
    }
  }, [data]);

  useEffect(() => {
    document.title = `${t("Work History")} | ShowStar`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div>
        <Container fluid>
          <Row>
            <Col lg={12}>
              <div className="mt-3">
                {
                  dataFormat?.length > 0 ? dataFormat?.map((historyItem: any, index: any) => (
                    <div key={index} className="mb-3">
                      <Collapse
                        expandIconPosition="end"
                        defaultActiveKey={[1]}
                        items={[
                          {
                            key: index + 1,
                            label: historyItem?.title,
                            children: (
                              <div
                                id="customerList"
                                style={{
                                  boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)",
                                  margin: 0,
                                  background: "#F8F8F8",
                                }}
                              >
                                <ListGroup flush>
                                  {historyItem?.details?.map(
                                    (detail: any, detailIndex: any) => (
                                      <ListGroupItem key={detailIndex}>
                                        <strong>{t(detail?.label)}:</strong>{" "}
                                        {detail?.value}
                                      </ListGroupItem>
                                    )
                                  )}
                                </ListGroup>
                              </div>
                            ),
                          },
                        ]}
                      />
                    </div>
                  )) : (
                    <>
                      <div className="pb-3">{t('No Data')}</div>
                    </>
                  )
                }
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default WorkHistoryTab;